import { CHECKBOX_STATUS, Checkbox } from 'ui/checkbox';
import { Skeleton } from 'ui/skeleton';
import { GridRow } from 'ui/indexPages/tables/grid';
import { WORKFLOW_WEBHOOK_GRIDS } from '../constants';

type Props = {
  numRows: number;
};

export const SkeletonRows = ({ numRows = 10 }: Props) => (
  <>
    {Array(numRows)
      .fill({})
      .map((r, i) => (
        <GridRow gridLayout={WORKFLOW_WEBHOOK_GRIDS} data-test="skeleton-row" key={i}>
          <Checkbox data-test="row-checkbox" status={CHECKBOX_STATUS.UNCHECKED} />
          {Array(3)
            .fill({})
            .map((a, b) => (
              <div key={b}>
                <Skeleton data-test="workflow-webhook-skeleton-cell" />
              </div>
            ))}
        </GridRow>
      ))}
  </>
);
